


































































import { Component, Vue, Watch } from 'vue-property-decorator';
import UserToken from '@/models/UserToken';
import { getUserTokensPrescriber, getUserTokenRefreshRegenerate, saveUserCrmUrl } from '@/api/api';
import AuthModule from '@/store/AuthModule';
import UserTokenIpsForm from '@/components/prescriber/UserTokenIpsForm.vue';

@Component({
  components: {
    UserTokenIpsForm,
  },
  filters: {},
})
export default class UserTokensList extends Vue {
  userTokens: UserToken[] = [];
  loading: boolean = false;
  loadingContent: boolean = false;
  background_color: string = "background-color:" + AuthModule.personal_color;
  crm_url: string = '';
  showLoginApiKey: boolean = false;

  async created() {
    this.loading = true;
    await this.fetch();
    this.crm_url = AuthModule.crmUrl;
    this.loading = false;
  }

  async saveCrmUrl() {
    const { data } = await saveUserCrmUrl(this.crm_url);
    const $vs = (this as any).$vs;
    $vs.notify({
      type: 'confirm',
      color: 'success',
      position: 'top-right',
      text: "CRM URL saved",
    });
  }

  async fetch() {
    this.loadingContent = true;
    const { data } = await getUserTokensPrescriber();
    this.userTokens = data;
    this.loadingContent = false;
  }

  refreshDialog(userToken: UserToken) {
      const $vs = (this as any).$vs;
      $vs.dialog({
          type: 'confirm',
          color: 'success',
          title: "Regnération Accès API",
          text: "Etes vous sur de vouloir regénéré les acces API ? Cette Action est irréversible",
          accept: () => this.refreshToken(userToken.id),
          acceptText: 'Confirmer',
          cancelText: 'Annuler',
      });
  }

  async refreshToken(id: any) {
    const { data } = await getUserTokenRefreshRegenerate(id);
    let ArrayUserTokens = this.userTokens;
    this.userTokens.forEach(function(value, key){
      if(data.id === value.id){
        ArrayUserTokens[key] = data;
      }
    });
    this.userTokens = ArrayUserTokens;
    this.$forceUpdate();
  }
}
